$(document).ready(function(){
// ANNOUNCEMENT BAR SLIDER
    $('.announcementbar_row').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        autoplay: true,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: "<button type='button' class='slick-prev pull-left'><img src='https://abbottoaks.com/cdn/shop/t/28/assets/prev_arrow.svg?v=26187956543410833161759480523'></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img src='https://abbottoaks.com/cdn/shop/t/28/assets/next_arrow.svg?v=27682653899508830991759480523'></button>",
    });
    $('.collection-slide').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 5,
        arrows: true,
        prevArrow: "<button type='button' class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M15 6l-6 6 6 6'/></svg></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M9 6l6 6-6 6'/></svg></button>",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: true,
                    centerPadding: '60px',
                    arrows: false,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '60px',
                    arrows: false,
                    dots: false
                }
            }

        ]
    });
    $('.collection-slide-sold').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        drag: false,
        slidesToScroll: 5,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: true,
                    centerPadding: '60px',
                    arrows: false,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '60px',
                    arrows: false,
                    dots: false
                }
            }

        ]
    });
    $('.collection-list').slick({
        centerMode: true,
        centerPadding: '120px',
        slidesToShow: 3,
        dots: false,
        arrows: true,
        prevArrow: "<button type='button' class='slick-prev pull-left'><img src='//milanco-store.myshopify.com/cdn/shop/t/4/assets/angle-prev-g.svg?v=147009790291874915191738076556'></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img src=//milanco-store.myshopify.com/cdn/shop/t/4/assets/angle-next-g.svg?v=140330819894840597541738076556'></button>",
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '80px',
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: true,
                    centerPadding: '40px',
                    arrows: false,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            }
        ]
    });
    $('.your-style-slide').slick({
        dots: false,
        centerMode: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        prevArrow: "<button type='button' class='slick-prev pull-left'><img src='{{ 'angle-prev-g.svg' | asset_url }}'></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img src='{{ 'angle-next-g.svg' | asset_url }}'></button>",
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    centerMode: false,
                    slidesToShow: 1.3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            }
        ]
    });
    AOS.refresh()
})